import topTitle from '@/components/title';
import { mailingLook } from '../request';
export default {
  components: {
    topTitle
  },
  props: {
    claimsId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      previewVisible: false,
      mailingInfo: {}
    };
  },
  created() {
    setTimeout(() => {
      this.init();
    }, 400);
  },
  methods: {
    async init() {
      this.mailingInfo = await mailingLook({
        claimsId: this.claimsId
      });
      this.previewVisible = true;
    }
  }
};